function slicedTin (tin) {
  let p = tin;
    return `${p.slice(0, 3)}-${p.slice(3, 6)}-${p.slice(-3)}`
}

export default slicedTin;
